"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentArgs = exports.backgroundColorMapping = exports.availableColors = exports.availableVariants = void 0;

var _nestedRoles = _interopRequireDefault(require("@digital-hig/theme-data/lib/build/json/lightTheme/nestedRoles.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _lightThemeData$token = _nestedRoles.default.tokens,
    colors = _lightThemeData$token.colors,
    typography = _lightThemeData$token.typography;
var unwantedVariants = ["body-copy-large-compact", "body-copy-medium-compact", "body-copy-small-compact"];
var availableVariants = Object.freeze(Object.keys(typography).filter(function (value) {
  return !unwantedVariants.includes(value);
}));
exports.availableVariants = availableVariants;
var excludeColors = ["ink-hover", "ink-focus", "ink-success"];
var availableColors = Object.freeze([""].concat(_toConsumableArray(Object.keys(colors).filter(function (value) {
  return (value.startsWith("ink-") || value.startsWith("text-")) && !excludeColors.includes(value);
}))));
exports.availableColors = availableColors;
var backgroundColorMapping = {
  "ink-on-fill-primary": colors["fill-primary"],
  "ink-on-fill-engage": colors["fill-engage"],
  "ink-on-fill-alert": colors["fill-alert"],
  "ink-on-fill-success": colors["fill-success"],
  "ink-on-fill-warning": colors["fill-warning"],
  "text-on-fill-primary": colors["fill-primary"]
};
exports.backgroundColorMapping = backgroundColorMapping;
var componentArgs = {
  className: {
    table: {
      disable: true
    }
  },
  children: {
    table: {
      disable: true
    }
  },
  style: {
    table: {
      disable: true
    }
  },
  variant: {
    control: {
      type: "select"
    },
    options: availableVariants
  },
  color: {
    control: {
      type: "select"
    },
    options: availableColors
  }
};
exports.componentArgs = componentArgs;